import { UserLoginResponse } from '@core/models';
import { SystemTheme } from '@core/models/base.model';

export class SetUser {
  static readonly type = '[User] Get User';
  static readonly desc = 'getting user';

  constructor(public payload: UserLoginResponse) {}
}

export class SetTokens {
  static readonly type = '[User] Set Tokens';
  static readonly desc = 'Set tokens';

  constructor(public payload: Pick<UserLoginResponse, 'accessToken' | 'refreshToken'>) {}
}

export class SetUserTheme {
  static readonly type = '[SetUserTheme] Get Theme';
  static readonly desc = 'getting theme';

  constructor() {}
}

export class SetIsAdmin {
  static readonly type = '[SetIsAdmin] Get isAdmin';
  static readonly desc = 'getting isAdmin';
  constructor() {}
}

export class SetSystemTheme {
  static readonly type = '[SetSystemTheme] Set system Theme';
  static readonly desc = 'getting system theme';

  constructor(public payload: SystemTheme) {}
}

export class GetSystemTheme {
  static readonly type = '[GetSystemTheme] Get system Theme';
  static readonly desc = 'getting system theme';

  constructor() {}
}

export class SetCompanyLogo {
  static readonly type = '[SetCompanyLogo] Get company logo';
  static readonly desc = 'getting company logo';

  constructor() {}
}

export class ResetUserState {
  static readonly type = '[ResetUserState] Reset user state';
  static readonly desc = 'resetting user state';

  constructor() {}
}
